import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { useLanguage } from "../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import { LuTrash2 } from "react-icons/lu";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const SettingsPropertyModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
    setPropData,
    propData,
    setOpenDelete
}) => {
    const { t } = useLanguage()
    const { org_id } = useParams()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });


    const handleChange = (e) => {
        const { name, value } = e.target;

        setPropData(prev => {
            const updated = {
                ...prev,
                [name]: value
            };

            if (name === "base_url") {
                try {
                    const url = new URL(
                        value.includes("://") ? value : `https://${value}`
                    );

                    updated.domain = url.hostname
                        .toLowerCase()
                        .replace(/^www\./, "");
                } catch {
                    updated.domain = "";
                }
            }

            return updated;
        });
    };

    const handleDeploymentChange = (value) => {
        setPropData(prev => ({
            ...prev,
            deployment_enabled: value
        }));
    };

    const handleSave = async () => {
        if (!propData.name.trim()) {
            setErrorMessage({ message: t.properties.name_required, display: true });
            return;
        }

        if (!propData.base_url.trim()) {
            setErrorMessage({ message: t.properties.base_url_required, display: true });
            return;
        }

        if (!propData.domain.trim()) {
            setErrorMessage({ message: t.properties.domain_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/update_property`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    property_id: propData.id,
                    name: propData.name,
                    base_url: propData.base_url,
                    domain: propData.domain,
                    deployment: propData.deployment_enabled
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                fetchRecords()
                closeModal()
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const handleDelete = () => {
        setOpenDelete(true)
        closeModal()
        setPropData({
            name: "",
            domain: "",
            base_url: ""
        })
    }

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.properties.update_title}</p>
                <button className="context_window_footer_btn_delete fade-in" onClick={handleDelete}><LuTrash2 /></button>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">{t.name} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            value={propData.name}
                            onChange={handleChange}
                            placeholder="Ex: My website"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">{t.properties.base_url} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="base_url"
                            value={propData.base_url}
                            onChange={handleChange}
                            placeholder="https://www.mywebsite.com"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">{t.properties.domain} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="domain"
                            value={propData.domain}
                            onChange={handleChange}
                            placeholder="mywebsite.com"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            {t.properties.deployment} <MandatorySign message={t.mandatory_field} />
                        </label>

                        <Dropdown>
                            <Dropdown.Toggle
                                as="div"
                                className="register_form_first fade-in"
                                style={{ cursor: "pointer" }}
                            >
                                {propData.deployment_enabled ? t.properties.enabled : t.properties.disabled}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="custom_dropdown_menu">
                                <div className="dropdown_container fade-in">
                                    <div className="scrollable_dropdown_cont">
                                        <button
                                            type="button"
                                            className="settings_link"
                                            onClick={() => handleDeploymentChange(true)}
                                        >
                                            <i>
                                                {propData.deployment_enabled
                                                    ? <MdOutlineCheckCircle />
                                                    : <MdOutlineCircle />
                                                }
                                            </i>
                                            {t.properties.enabled}
                                        </button>

                                        <button
                                            type="button"
                                            className="settings_link"
                                            onClick={() => handleDeploymentChange(false)}
                                        >
                                            <i>
                                                {!propData.deployment_enabled
                                                    ? <MdOutlineCheckCircle />
                                                    : <MdOutlineCircle />
                                                }
                                            </i>
                                            {t.properties.disabled}
                                        </button>
                                    </div>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                    <p className="warning_source_message fade-in">
                        {t.properties.verify_domain_warn} <br />
                        {propData.deployment_enabled && (
                            t.properties.deployment_warn
                        )}
                    </p>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SettingsPropertyModal;